import * as React from 'react';
import { Tab } from '../../internal/Tab/Tab';
import { ScrollTrack } from '../../internal/ScrollTrack/ScrollTrack';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const TabsComponent = _ref => {
  let {
    activeTab,
    tabs,
    onChange
  } = _ref;
  const [focusVisible, setFocusVisible] = React.useState(false);
  const onClick = _ref2 => {
    let {
      value
    } = _ref2;
    setFocusVisible(false);
    onChange(value);
  };
  return /*#__PURE__*/_jsx(ScrollTrack, {
    setFocusVisible: setFocusVisible,
    activeTab: activeTab,
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: tabs.map(_ref3 => {
        let {
          value,
          title,
          disabled
        } = _ref3;
        return /*#__PURE__*/_jsx(Tab, {
          title: title,
          disabled: disabled,
          active: value === activeTab,
          focusVisible: focusVisible,
          onClick: e => onClick({
            e,
            value
          })
        }, value);
      })
    })
  });
};

/**
 * Компонент для рендера табов со стрелками прокрутки
 *
 * @deprecated требуется реализация с другим API для фикса https://jira.cian.tech/browse/CD-113225
 */
export const Tabs = /*#__PURE__*/React.memo(TabsComponent);